<button tuiNotification class="banner" type="button" [icon]="icon" [size]="'m'" [routerLink]="link">
  <div tuiTitle>
    <strong>{{ title }}</strong>
  </div>

  <div tuiSubtitle>
    {{ description }}
  </div>
</button>
